import { render, staticRenderFns } from "./organizationStructure.vue?vue&type=template&id=6811ef8e&scoped=true"
import script from "./organizationStructure.vue?vue&type=script&lang=js"
export * from "./organizationStructure.vue?vue&type=script&lang=js"
import style0 from "./organizationStructure.vue?vue&type=style&index=0&id=6811ef8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6811ef8e",
  null
  
)

export default component.exports